import { createResizeObserverContext } from './Context';

export const { Provider: ResizeObserverProvider, useSelector: useResizeObserverSelector } =
  createResizeObserverContext();
